module.exports = __webpack_public_path__ + "media/impact4.e7235a9e.mp3";